import {useState} from 'react'
import {useAuthContext} from './useAuthContext'
import { useNavigate } from 'react-router-dom'; 
import { axiosInstance } from '../context/AuthContext';

const toAuthPayload = (data) => ({
    ...data.user,
    token: data.token,
});

export const useLogin = () => {
    const [error, setError] = useState(null)
    const [isLoading, setIsLoading] = useState(null)
    const {dispatch } = useAuthContext()
    const navigate = useNavigate(); 


    const login = async (email, password) => {
        setIsLoading(true)
        setError(null)

        const response = axiosInstance.post('/auth/login', {email, password}).then(response => {
            const userInfo = toAuthPayload(response.data)
            localStorage.setItem('user', JSON.stringify(userInfo))
            dispatch({type: 'LOGIN', payload: userInfo})
            if (userInfo) {
                if (userInfo.permissions.length > 0) {
                    navigate('/gallery');
                } else {
                    navigate('/welcome');
                }
            }
        
            
        }).catch(error => {
            const errorMessage = error.response?.data?.error || 'Login failed'
            setError(errorMessage)
            
            if (errorMessage.includes('pending') || errorMessage.includes('disabled')) {
                const storedUser = JSON.parse(localStorage.getItem('user'))
                if (storedUser) {
                    if (errorMessage.includes('pending')) {
                        storedUser.status = 'pending'
                    } else if (errorMessage.includes('disabled')) {
                        storedUser.status = 'disabled'
                    }
                    localStorage.setItem('user', JSON.stringify(storedUser))
                    navigate('/welcome')
                }
            }
        }).finally(() => {
            setIsLoading(false)
        });
    }

    const loginWithGoogle = async (credential) => {
        setIsLoading(true)
        setError(null)
        try {
            const response = await axiosInstance.post('/auth/google', { credential })
            const userInfo = toAuthPayload(response.data)
            localStorage.setItem('user', JSON.stringify(userInfo))
            dispatch({ type: 'LOGIN', payload: userInfo })
            if (userInfo.permissions && userInfo.permissions.length > 0 && userInfo.status === 'active') {
                navigate('/gallery')
            } else {
                navigate('/welcome')
            }
        } catch (err) {
            const errorMessage = err.response?.data?.error || 'Google sign-in failed'
            setError(errorMessage)
        } finally {
            setIsLoading(false)
        }
    }

    return { login, loginWithGoogle, isLoading, error }
}